<style lang="less" scoped>
  p {
    margin: 0;
    padding: 0;
  }

  .footer-box {
    background-color: #F2F2F2;
    height: 310px;


    div.footer-top {
      width: 1180px;
      margin: 0 auto;
      height: 260px;
      padding-top: 100px;
      font-size: 14px;


      table {
        width: 100%;
        height: 160px;
        border-bottom: 1px solid #ddd;

        td {
          p {
            line-height: 30px;
          }

          a {
            color: #666;
          }

          a:hover {
            color: #2468F2;
          }

          .tel-label {
            padding-left: 24px;
            height: 30px;
            color: #555;
            font-weight: 500;
            width: 120px;
            background: url('https://cdn.gogudata.com/gogu-home-page/static/img/icon_telephone_small_fill.png') left 2px no-repeat;
          }

          .mail-label {
            padding-left: 24px;
            height: 30px;
            color: #555;
            font-weight: 500;
            width: 120px;
            background: url('https://cdn.gogudata.com/gogu-home-page/static/img/icon_mailbox_small_fill.png') left 2px no-repeat;
          }
        }
      }
    }


  }

  .footer-bottom {
    float: none;
    width: 1180px;
    margin: 0 auto;

    .copyright {
      clear: both;
      padding-top: 15px;
      text-align: center;
      color: #3A3A3A;

      .declare {

        // cursor: pointer;
        a {
          text-decoration: none !important;
          color: #3A3A3A !important
        }
      }
    }
  }

  div.cl {
    clear: both;
  }
</style>
<template>

  <div class="footer-box">
    <div class="footer-top">
      <table>
        <tr>
          <td valign="top" width="8%"><strong style="color:#555">便捷入口</strong></td>
          <td valign="top" width="30%"><a href="https://www.gogudata.com/macro-mind">宏观行业数据　 </a><a
              href="https://www.gogudata.com/linglei">另类数据　</a>　<a
              href="https://www.gogudata.com/new-stock-list">新股数据　</a><br /><br />

            <a href="https://www.gogudata.com/tradeData">交易数据　　　</a>　　<a href="/pr">舆情监测　</a>　　

            <a href="https://www.gogudata.com/business">商务合作　</a> <br /><br /> <a
              href="https://www.gogudata.com/aboutus">关于我们　　　</a>
          </td>
          <td valign="top" width="22%">
            <div class="tel-label">咨询热线</div>
            <p style="color:#333">0755-86533518（分机号835）
            </p>
            <p style="color:#666">8:45-17:45(法定假日除外)</p>

          </td>
          <td valign="top" width="22%">
            <div class="mail-label">客服邮箱</div>
            <p style="color:#333">business@gogudata.com
            </p>

          </td>
          <td valign="top" width="8%" style="color:#333!important">合作微信</td>
          <td valign="top"><img width="100%"
              src="https://gogudata.oss-cn-hangzhou.aliyuncs.com/gogu-home-page/static/img/%E5%AE%A2%E6%9C%8D%E5%BE%AE%E4%BF%A1.jpg"
              alt="">
          </td>
        </tr>
      </table>
      <div class="cl"></div>
    </div>

    <div class="footer-bottom">
      <p data-v-75aec375="" class="copyright"><span data-v-75aec375="" class="declare">版权所有 © 勾股大数据（深圳）有限公司 <a
            data-v-75aec375="" target="_blank" href="https://beian.miit.gov.cn"> 粤ICP备
            17120683号 </a></span></p>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    mounted() {

    },
    methods: {

      go_free() {
        if (window.gogu_user_info) {
          window.location = '/?free_window=1'
        } else {

          let page_url = encodeURIComponent('https://www.gogudata.com/?free_window=1')
          window.location = window.LOGIN_HOST + "/login?call_back_url=" + page_url
        }
      }

    }
  }
</script>
